// extracted by mini-css-extract-plugin
export default {"box":"Statistics_box__+YCaG","title":"Statistics_title__eCJPs","text":"Statistics_text__6inHx"};